import React, { useState} from 'react'
import {Select, Box,Grid, TextField,Button,Card,Divider,useMediaQuery, Container,IconButton,OutlinedInput, FormHelperText,FormControl,InputLabel,InputAdornment,MenuItem } from '@mui/material';
import { Typography } from 'material-ui';
import { useDispatch,useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { fetchData, postData } from '../../../redux/apiSlice';
import swal from "sweetalert";
import { Formik } from 'formik';
import * as Yup from 'yup';
import InputMask from 'react-input-mask';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

let RequestFormInitialValues = {
  firstname: '',
  lastname: '',
  companyName: '',
  phone: '',
  email : '',
  communicationEmail : '',
  companyId : ''
};

function CreditConEventRegistration(props) {
    const isMobile = useMediaQuery('(max-width:600px)');
    const dispatch = useDispatch();
    const [registerEmail, setRegisterEmail] = useState('');
    const [emailError, setEmailError] = useState("");
    const [isAffiliate,setIsAffiliate] = useState("");
    const [showForm,setShowForm] = useState(false);
    const [btn,setBtn] = useState(false);
    const [disableBtn, setDisableBtn] = useState(false);
    const navigate = useNavigate();

    const changeIsAffiliateValue = (event) => {
        var value = event.target.value;
        console.log("event.target.value:",event.target.value)
        setIsAffiliate(value);
        if(value == "No") {
            setShowForm(true);
        }else {
            setShowForm(false);
        }
      };

    const accountSchema = Yup.object() .shape({
        firstname: Yup.string()
                        .min(2, 'Too Short!')
                        .max(50, 'Too Long!')
                        .required('Please enter your full Name.'),
            
        lastname: Yup.string()
                    .min(2, 'Too Short!')
                    .max(50, 'Too Long!')
                    .required('Please enter your last Name.'),
        email: Yup.string()
                .matches(/^(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24})$/i, "Invalid email format.")
                .required('Please enter your email address.'),
        communicationEmail: Yup.string()
                .matches(/^(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24})$/i, "Invalid email format.")
                .required('Please enter your email address.'),
        phone: Yup.string()
                .test(
                    'is-10-digits',
                    'Must be 10 digits.',
                    (value) => value && value.replace(/\D/g, '').length === 10 // Ensure only numeric digits are counted
                )
                .required('Please enter your mobile number.'),
        companyName :   Yup.string()      
                    .required('Please enter your company name.'),
       
    });

    const validateEmail = (email) => {
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    
            if (!email) {
                return "Please enter your email address.";
            } 
            if (!emailRegex.test(email)) {
                return "Invalid email format."; 
            }
            return "";
    };


    const validateRegisterEmail = async() => {
    // var myEmail = event.target.value;
    const errorMessage = validateEmail(registerEmail);
    setEmailError(errorMessage);
    
    
    if (errorMessage) {
        return;
    }

    const apiUrl = '/validateAffiliateEmail'; // Replace with your API endpoint
    const args = {
        email : registerEmail,
        internal: 1,
    };
    try{
    const res = await dispatch(postData({ apiUrl, args })).unwrap();
    if(res){
        if(res.success === true) {
        RequestFormInitialValues.firstname = res.user.first_name;
        RequestFormInitialValues.lastname = res.user.last_name;
        RequestFormInitialValues.email = res.user.email;
        RequestFormInitialValues.phone = res.user.phone_no;
        RequestFormInitialValues.companyName = res.user.company ? res.user.company.company_name : '';
        RequestFormInitialValues.communicationEmail = res.user.reference_affiliates ? res.user.reference_affiliates.communication_email : '';
        RequestFormInitialValues.companyId = res.user.company_master_id;
        console.log("RequestFormInitialValues:"+JSON.stringify(RequestFormInitialValues));
        setShowForm(true);
        setDisableBtn(true);
        }else{
            swal({
                title: "Failed",
                text: res.message,
                icon: "error",
                button: "Ok",
            })
        }
    }
    }catch (error) {
        console.error("Error validating email:", error);
    }
    
    };

    const CreateUser = async(values,{ resetForm }) => {
        setBtn(true);
        const apiUrl = '/creditConEventregistration'; // Replace with your API endpoint
        const args = {
            email : values.email,
            communicationEmail : values.communicationEmail,
           
            firstname : values.firstname,
            lastname : values.lastname,
            phone : values.phone, 
            companyName : values.companyName, 
            companyId : values.companyId,
        };
        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        if(res){
        //   handleFreezStop();
            if(res.success === true) {
            // setTimeout(function () {
                swal({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    button: "Ok",
                })
            // }, 5000);
            // setBtn(false);
            setTimeout(() => {
                // window.location.href = "https://www.m2gala.com/login";
                navigate('/topgolf-social-media-links');
            }, 2000); 
            
             // }
            }else{
                setBtn(false);
                setDisableBtn(false);
                setShowForm(false);
                let errorMessages = "";
                if (typeof res.message === "string") {
                    // Case 1: Message is a plain string
                    errorMessages = res.message;
                } else if (typeof res.message === "object") {
                    // Case 2: Message is an object (with arrays)
                    errorMessages = Object.values(res.message).flat().join("\n");
                }
                swal({
                    title: "Failed",
                    text: errorMessages,
                    icon: "error",
                    button: "Ok",
                });
            }
        }
        };
    
    return (
        <>
            <Container maxWidth="md">
                <Grid Container item lg={12} md={12} sm={12} xs={12} sx={{display:"flex",justifyContent:"center",alignItems:'flex-end',marginTop:isMobile?"4%":"1%"}}>
                    {/* <Grid item  >
                            <img src={require('../../../assets/images/m2_gala.png')} style={{width: isMobile ? "26vw" : "9vw",height:"auto"}}/>
                    </Grid>
                    <Grid item  >
                            <img src={require('../../../assets/images/epr_circle.png')} style={{width: isMobile ? "25vw" : "8.5vw",height:"auto"}}/>
                    </Grid> */}
                    <Grid item sx={{marginTop:"4%"}}>
                        {/* <Typography >Partnered with</Typography>                     */}
                        <img src={require('../../../assets/images/mainLogo.jpg')} style={{width: isMobile ? "40vw":"11vw"}} />
                    </Grid> 
                </Grid>                
            </Container>
            <Container maxWidth="sm">
                <Card sx={{boxShadow:"none",marginTop:isMobile?"4%":"2%"}}>
                    <Grid item Container lg={12} md={12} sm={12} xs={12} sx={{display:"flex",justifyContent:"center",paddingBottom:"10px",color:"green"}}>
                        <Typography style={{fontSize:"24px",color:"green"}}><b>Register </b></Typography>
                    </Grid>
                    <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                            <Box sx={{ width: "100%", maxWidth: 500 }}> {/* Optional: limit max width */}
                                <Select
                                    fullWidth
                                    labelId="is-affiliate-label"
                                    id="isAffiliate"
                                    name="isAffiliate"
                                    value={isAffiliate || ""}
                                    onChange={changeIsAffiliateValue} // make sure to define this function
                                    // onBlur={handleBlur} // make sure to define this too if using Formik
                                    displayEmpty
                                    input={<OutlinedInput label="Are You An Affiliate?*" />}
                                    MenuProps={MenuProps}
                                    sx={{
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderWidth: "2px",
                                        borderStyle: "solid",
                                        borderColor: "black",
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "black",
                                    },
                                    }}
                                    // className="cobrandTextField"
                                >
                                    <MenuItem value="" disabled>
                                    Are You An Affiliate?*
                                    </MenuItem>
                                    <MenuItem value="Yes">Yes</MenuItem>
                                    <MenuItem value="No">No</MenuItem>
                                </Select>
                            </Box>
                        </Box>
                    </Grid>
                    {
                        isAffiliate == "Yes"?
                        <>
                           <Grid item Container lg={12} md={12} sm={12} xs={12}  sx={{display:"flex",justifyContent:"center"}} mt={2}>
                            <TextField id="registerEmail"
                            size="small" 
                            label="Please Enter Your MyFreeScoreNow Email Address" 
                            variant="outlined" 
                            fullWidth 
                            margin='dense'
                            name="registerEmail"
                            value={registerEmail}
                            onChange={(event) => setRegisterEmail(event.target.value)}
                            error={Boolean(emailError)} 
                                helperText={emailError}
                            />
                            </Grid>
                            <Grid Container item sx={{textAlign: isMobile ? "center": "right"}} mt={1} lg={12} md={12} sm={12} xs={12}>
                                <Button variant="contained" color='warning' sx={{minWidth:213,backgroundColor:"#FF690B",color:"white",fontWeight:"bold", borderRadius:"7px"}} onClick={validateRegisterEmail} disabled={disableBtn}>Submit</Button>
                            </Grid>
                        </>
                        : ''
                    }
                    
                
                    {
                        showForm ?
                        <>
                        <Formik
                                    initialValues={RequestFormInitialValues}
                                    validationSchema={accountSchema}
                                    // onSubmit={async(values, { resetForm }) => {
                                    //     CreateUser(values);
                                    // }}
                                    onSubmit={CreateUser}
                                    >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, resetForm }) => (
                <>
                        <Grid Container item mt={1} lg={12} md={12} sm={12} xs={12}>
                            <Divider sx={{height:"0.5px",backgroundColor:"#757575"}} />
                        </Grid>
                        <Grid item Container lg={12} md={12} sm={12} xs={12}  mt={1}  sx={{display:"flex",justifyContent:"center"}}>
                            <TextField id="firstname" 
                            size="small" 
                            label="First Name" 
                            variant="outlined" 
                            fullWidth 
                            name="firstname"
                            onChange={handleChange('firstname')}
                            onBlur={handleBlur('firstname')}
                            value={values.firstname} 
                            margin='dense'
                            helperText={touched.firstname && errors.firstname ? errors.firstname : null}
                            error={touched.firstname && errors.firstname ? errors.firstname : null}
                            />
                        </Grid>
                        <Grid item Container lg={12} md={12} sm={12} xs={12}  mt={1}  sx={{display:"flex",justifyContent:"center"}}>
                            <TextField id="lastname" 
                            size="small" 
                            label="Last Name" 
                            variant="outlined" 
                            fullWidth 
                            name="lastname"
                            onChange={handleChange('lastname')}
                            onBlur={handleBlur('lastname')}
                            value={values.lastname}  
                            margin='dense'
                            helperText={touched.lastname && errors.lastname ? errors.lastname : null}
                            error={touched.lastname && errors.lastname ? errors.lastname : null}
                            />
                        </Grid>
                        <Grid item Container lg={12} md={12} sm={12} xs={12}  mt={1}  sx={{display:"flex",justifyContent:"center"}}>
                             <InputMask 
                             id="phone" 
                             mask='(999) 999-9999'
                             maskChar={null}
                             size="small" 
                             type="text"
                             label="Phone No" 
                             variant="outlined" 
                             fullWidth 
                             name="phone"
                             autoComplete="phone"
                            //  onChange={handleChange('phone')}
                            onChange={(e) => {
                                const numericValue = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                                setFieldValue('phone', numericValue); // Set only numbers to Formik
                            }}
                             onBlur={handleBlur('phone')}
                             value={values.phone}  
                             margin='dense'
                             helperText={touched.phone && errors.phone ? errors.phone : null}
                             error={touched.phone && errors.phone ? errors.phone : null}>
                                {(inputProps) =>
                                    <TextField
                                        label="Phone Number" variant="outlined"
                                        {...inputProps}
                                    />
                                }
                             </InputMask>
                        </Grid>
                        <Grid item Container lg={12} md={12} sm={12} xs={12} mt={1}  sx={{display:"flex",justifyContent:"center"}}>
                            <TextField 
                            id="outlined-basic" 
                            size="small" 
                            label="Company Name" 
                            variant="outlined" 
                            fullWidth 
                            name="companyName"
                            value={values.companyName}  
                            onChange={handleChange('companyName')}
                            onBlur={handleBlur('companyName')}
                            margin='dense'
                            helperText={touched.companyName && errors.companyName ? errors.companyName : null}
                            error={touched.companyName && errors.companyName ? errors.companyName : null}
                            />
                        </Grid>
                        <Grid item Container lg={12} md={12} sm={12} xs={12}  mt={1}  sx={{display:"flex",justifyContent:"center"}}>
                            <TextField id="outlined-basic" 
                            size="small" 
                            label="Email" 
                            variant="outlined" 
                            fullWidth 
                            name="email"
                            value={values.email}  
                            onChange={handleChange('email')}
                            onBlur={handleBlur('email')}
                            margin='dense'
                            helperText={touched.email && errors.email ? errors.email : null}
                            error={touched.email && errors.email ? errors.email : null}
                            />
                        </Grid>
                        <Grid item Container lg={12} md={12} sm={12} xs={12}  mt={1}  sx={{display:"flex",justifyContent:"center"}}>
                            <TextField id="outlined-basic" 
                            size="small" 
                            label="Company Email" 
                            variant="outlined" 
                            fullWidth 
                            name="communicationEmail"
                            value={values.communicationEmail}  
                            onChange={handleChange('communicationEmail')}
                            onBlur={handleBlur('communicationEmail')}
                            margin='dense'
                            helperText={touched.communicationEmail && errors.communicationEmail ? errors.communicationEmail : null}
                            error={touched.communicationEmail && errors.communicationEmail ? errors.communicationEmail : null}
                            />
                        </Grid>
                        <Grid item Container lg={12} md={12} sm={12} xs={12}  mt={1}  sx={{textAlign: isMobile ? "center":"right"}}>
                            <Button variant="contained" color='warning' onClick={handleSubmit} disabled={btn}  sx={{minWidth:213,backgroundColor:"#FF690B",color:"white",fontWeight:"bold", borderRadius:"7px"}}>Submit</Button>
                        </Grid>
                        </>
                    )}
                    </Formik>
                        </>
                        : ''
                    }
                </Card> 
            </Container>
        </>
    )
    }

export default CreditConEventRegistration;